import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CreatorPublicDto } from '../api/types';

interface AuthState {
  token: string | null;
  creator: CreatorPublicDto | null;
  mustChangePassword: boolean;
  setSession: (token: string, creator: CreatorPublicDto, mustChange: boolean) => void;
  updateCreator: (creator: CreatorPublicDto) => void;
  clear: () => void;
}

/**
 * Persisted across reloads via zustand/persist (localStorage). The API
 * client reads token straight off the store so we can attach the auth
 * header from non-React code paths too.
 *
 * On hard-refresh the server can still 401 (e.g. token rotated/secret
 * changed); the client's 401 handler clears the store and redirects.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      creator: null,
      mustChangePassword: false,
      setSession: (token, creator, mustChange) =>
        set({ token, creator, mustChangePassword: mustChange }),
      updateCreator: (creator) => set({ creator, mustChangePassword: creator.mustChangePassword }),
      clear: () => set({ token: null, creator: null, mustChangePassword: false }),
    }),
    {
      name: 'snapmon-creator-session',
    },
  ),
);
